import React from "react";
import "./i18n";
import "./styles/index.scss";
import "./styles/base.scss";
import Auth0ProviderWithHistory from "./Auth0ProviderWithHistory";
import AppRoutes from "./AppRoutes";
import { GlobalProvider } from "./contexts/GlobalContext";

const App: React.FC = () => {
  return (
    <Auth0ProviderWithHistory>
      <GlobalProvider>
        <AppRoutes />
      </GlobalProvider>
    </Auth0ProviderWithHistory>
  );
};

export default App;
